import { render, staticRenderFns } from "./expressAuthorization.vue?vue&type=template&id=4843b89b&scoped=true&"
import script from "./expressAuthorization.vue?vue&type=script&lang=js&"
export * from "./expressAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./expressAuthorization.vue?vue&type=style&index=0&id=4843b89b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843b89b",
  null
  
)

export default component.exports